import { fontFamilies, mesaColorNames } from '@/src/common/theme'
import { randomUUID } from '@/src/common/utils/randomUUID'
import { useMemo, type ComponentProps } from 'react'
import { Platform } from 'react-native'
import Svg, { Text, Path, FeColorMatrix, Filter, Defs } from 'react-native-svg'

export function CashbackPreset(props: ComponentProps<typeof Svg> & { grayscale?: boolean }) {
  const uniqueId = useMemo(() => randomUUID(), [])
  const filterId = `grayscale-${uniqueId}` as const
  const grayscale = props.grayscale ? (`url(#${filterId})` as const) : undefined

  function TextBase(textProps: ComponentProps<typeof Text>) {
    return (
      <Text
        x={Platform.OS === 'web' ? '50%' : '30.5%'}
        y="40%"
        fontSize={13}
        fontWeight={700}
        textAnchor="middle"
        alignmentBaseline="middle"
        fontFamily={fontFamilies['PlusJakartaSans-Bold']}
        strokeLinecap="round"
        strokeLinejoin="round"
        {...textProps}
      >
        {props.children}
      </Text>
    )
  }

  return (
    <Svg width={63} height={63} viewBox="0 0 63 63" fill="none" {...props}>
      <Defs>
        <Filter id={filterId}>
          <FeColorMatrix type="saturate" values="0" />
        </Filter>
      </Defs>

      {/* backdrop */}
      <Path
        d="M0 8a8 8 0 018-8h47a8 8 0 018 8v47a8 8 0 01-8 8H8a8 8 0 01-8-8V8z"
        fill={mesaColorNames['Wide/100 #C6FFF5']}
        filter={grayscale}
      />

      {/* text outline */}
      <TextBase
        strokeWidth={5}
        fill={mesaColorNames['Mesa - Brand/Secondary #223843']}
        stroke={mesaColorNames['Mesa - Brand/Secondary #223843']}
        filter={grayscale}
      />

      {/* text fill */}
      <TextBase
        strokeWidth={0.01}
        fill={mesaColorNames['Mesa Primary Scale/400 - Brand #00DFC9']}
        stroke={mesaColorNames['Mesa Primary Scale/400 - Brand #00DFC9']}
        filter={grayscale}
      />

      {/* thumb */}
      <Path
        d="M29.88 36.294h3.196a3.196 3.196 0 100-6.392h-4.793c-.959 0-1.758.32-2.237.959l-8.948 8.628"
        stroke="#223843"
        strokeWidth={3}
        strokeLinecap="round"
        strokeLinejoin="round"
        filter={grayscale}
      />
      {/* rest of hand */}
      <Path
        d="M23.49 45.88l2.556-2.236c.48-.64 1.278-.959 2.237-.959h6.391c1.758 0 3.356-.64 4.474-1.918l7.35-7.03a3.198 3.198 0 10-4.394-4.65l-6.71 6.232M15.5 37.891l9.587 9.587"
        stroke="#223843"
        strokeWidth={3}
        strokeLinecap="round"
        strokeLinejoin="round"
        filter={grayscale}
      />
    </Svg>
  )
}
